/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactCopyright } from '../../models/contact-copyright';
import { ContactCopyrightPartial } from '../../models/contact-copyright-partial';

export interface UpdateCopyright$Params {
  id: number;
      body?: ContactCopyrightPartial
}

export function updateCopyright(http: HttpClient, rootUrl: string, params: UpdateCopyright$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactCopyright>> {
  const rb = new RequestBuilder(rootUrl, updateCopyright.PATH, 'patch');
  if (params) {
    rb.query('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactCopyright>;
    })
  );
}

updateCopyright.PATH = '/editor/contact-copyrights';
